import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
//import 'semantic-ui-css/semantic.min.css';  // ← Agrega esta línea
import reportWebVitals from './reportWebVitals';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Solo en producción: en el dev server el bundle se sirve sin hash en el
// nombre (siempre "bundle.js"), así que un service worker cache-first lo
// cachearía una vez y lo serviría para siempre, sin importar los cambios de
// código ni los reloads.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
